import React, { useState, useEffect, lazy, Suspense } from 'react';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Button as IcButton } from 'antd';
// components or icons
import Button from "../../../Common/Components/Button";
import Checkbox from "../../../Common/Components/Checkbox";
import whiteRoy from "../../../../assets/img/icons/whiteRoy.svg";

// actions or functions or constants
import { gillRoyMoveDown } from "modules/Content/DragnDrop/actions";
import store, { RootState } from "store";
import { AUDIENCE_LISTS } from "constants/types";
import { getAudienceListsNamesOnlyService } from "modules/Services/AudienceService";
import { AudienceParams } from "../Components/AudienceHeader";
import { TAB_AUDIENCE } from "constants/paths";
import Unlink from "../../../../assets/img/unlink.svg";
import { getQueryCampaignId } from 'modules/EmailBrowser/utils';
import { unlinkContactsLists } from '../actions';

// Lazy loaded components
const FloatingNewListAsider = lazy(() => import("../Lists/FloatingNewListAsider"));
const ConfirmDialogWithModal = lazy(() => import("modules/Common/Components/ConfirmDialogWithModal"));

interface IDeleteSelected {
  isUnlink?: boolean
  // Flag for Contacts/Lists Unlinking from Campaign functionality
  selectedCount?: number;
  selectedListCount?: number
  loading?: boolean;
  deleteSuccess?: boolean;
  selectAll?: boolean;
  selectAllList?: boolean;
  deleteAllFlag?: boolean;
  checkedItems?: any[];
  deleteAllTotalCount?: number;
  contactsInList?: boolean;
  checkedItemsNewList?: any[];
  inProfiled?: boolean;
  unselectedContactIdsState?: any[];
  onClearSelection?: (value?: any) => void;
  onDeleteHandler?: (value?: any) => void;
  selectedOrganization?: string[];
  selectedDesignation?: string[];
  selectedPersonality?: string[];
  selectedStatus?: string[];
  addPeopleMode: boolean;
  handleAddToExistingList?: () => void;
  handleRemoveFromExistingList?: () => void;
  globalList: boolean;
  permanentDeleteHandler?: () => void;
  idForRecommendedContacts?: string;
  addGlobalPeopleMode?: boolean;
  searchTerm?: string
}

const DeleteSelected: React.FC<IDeleteSelected> = (props) => {
  const { page, tab: urlTab, subTab } = useParams<AudienceParams>();
  const {
    isUnlink,
    selectedListCount,
    loading,
    deleteSuccess,
    selectedCount,
    selectAll,
    selectAllList,
    deleteAllFlag,
    checkedItems,
    deleteAllTotalCount,
    contactsInList,
    checkedItemsNewList,
    inProfiled,
    unselectedContactIdsState,
    onDeleteHandler,
    onClearSelection,
    selectedOrganization,
    selectedDesignation,
    selectedPersonality,
    selectedStatus,
    addPeopleMode,
    handleAddToExistingList,
    handleRemoveFromExistingList,
    globalList,
    permanentDeleteHandler,
    idForRecommendedContacts,
    addGlobalPeopleMode,
    searchTerm
  } = props;
  const [confirm, setConfirm] = useState(false);
  const [permanentDeleteContact, setPermanentDeleteContact] = useState(false);
  const [permanentDeleteContactConfirm, setPermanentDeleteContactConfirm] = useState(false);
  const totalCount = useSelector((state: RootState) => state.peopleAudience.totalCount);
  const totalCountWithoutList = useSelector((state: RootState) => state.peopleAudience.totalCountWithoutList);
  const totalCountList = useSelector((state: RootState) => state.audienceListDetails.totalContacts);
  const listDataNames: any = useSelector((state: RootState) => state.audienceLists.listsDataNames);
  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  const tab = window.location.pathname.startsWith("/audiences/people") ? "peopleTab" : "listsTab";

  const campaignId = getQueryCampaignId();
  const isDetailsPage = urlTab === TAB_AUDIENCE.VIEW && subTab === undefined;
  const isSearchAddPeoplePage = urlTab === TAB_AUDIENCE.VIEW && (subTab === TAB_AUDIENCE.ALL || subTab === TAB_AUDIENCE.ADD);
  const listName = useSelector((state: RootState) => state.audienceListDetails.listName);
  const onListPage = window.location.pathname.includes("lists");
  const urlContainsAdd = window.location.pathname.includes("add");
  const onListPageOrGlobalList = (onListPage && !globalList) || (globalList && !onListPage);
  const globalListingWhenSearchInList = (isSearchAddPeoplePage && addPeopleMode && globalList);
  // const listName = getQueryListId() ? listDataNames.filter((list: any) => list.list_id === getQueryListId())[0]?.list_name : '';


  const deleteHandler = () => {
    setConfirm(true);
  };

  const permanentDelete = () => {
    setConfirm(true);
    setPermanentDeleteContact(true);
  }

  const onConfirm = () => {
    if (addPeopleMode && globalList) {
      handleAddToExistingList && handleAddToExistingList();
      onCancel();
      return
    }
    else if (addPeopleMode && !globalList) {
      handleRemoveFromExistingList && handleRemoveFromExistingList();
      onCancel();
      return
    }
    else if (isUnlink && checkedItems && checkedItemsNewList) {
      unlinkContactsLists(campaignId, checkedItems, checkedItemsNewList, false, deleteAllFlag, unselectedContactIdsState, [], searchTerm)
      onClearSelection && onClearSelection()
      onCancel();
      return
    }
    if (onDeleteHandler) onDeleteHandler();
    onCancel();
  };

  const onCancel = () => {
    setConfirm(false);
    setPermanentDeleteContact(false);
    setPermanentDeleteContactConfirm(false);
  };

  const onConfirmDelete = () => {
    if (permanentDeleteContact) {
      setPermanentDeleteContactConfirm(true);
      setConfirm(true);
      setPermanentDeleteContact(false);
    }
    else if (permanentDeleteContactConfirm) {
      permanentDeleteHandler && permanentDeleteHandler();
      setPermanentDeleteContactConfirm(false);
      onCancel();
    }
  }

  // for adding any messages when delete success of fail
  useEffect(() => {
    if (deleteSuccess) {
      setConfirm(false);
    }
  }, [deleteSuccess]);

  useEffect(() => {
    if ((selectedCount === 0 || selectedListCount === 0) && confirm) {
      setConfirm(false);
    }
  }, [selectedCount, selectedListCount]);

  useEffect(() => {
    const node = document.querySelector(".body-element");
    if (node) {
      if (!selectedCount && !selectedListCount && node.classList.contains("gillRoy-index")) {
        node.classList.remove("gillRoy-index");
      } else if (selectedCount !== 0 || selectedListCount !== 0) {
        node.classList.add("gillRoy-index");
      }
    }
  }, [selectedCount, selectedListCount, isOverlay]);

  useEffect(() => {
    if (confirm) document.body.classList.add("delete-contact-confirm-popover");
    else document.body.classList.remove("delete-contact-confirm-popover");
  }, [confirm]);

  useEffect(() => {
    return () => {
      // dropping down gillRoy when unmount
      gillRoyMoveDown();
      onCancel();
    };
  }, []);

  const createNewListHandler = () => {
    if (listDataNames.length === 0) {
      store.dispatch({
        type: AUDIENCE_LISTS.NAMES_LOAD,
      });
      getAudienceListsNamesOnlyService()
        .then((res) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
            listsDataNames: res.data.lists,
          });
        })
        .catch((err) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_FAIL,
          });
        });
    }
  };

  let DELETE_TEXT = isDetailsPage ? "Remove"
    : (isSearchAddPeoplePage && (addPeopleMode || addGlobalPeopleMode) && globalList)
      ? "Add to list"
      : (isSearchAddPeoplePage && addPeopleMode && !globalList) ? "Remove from list"
        : "Delete";

  let CONFIRM_BUTTON_TEXT = isDetailsPage ? permanentDeleteContact ? "Delete" : permanentDeleteContactConfirm ? "Ok" : "Confirm" : "Confirm";
  let CANCEL_BUTTON_TEXT = isDetailsPage ? permanentDeleteContact || permanentDeleteContactConfirm ? "Discard" : "Cancel" : "Cancel";
  let CONFIRMATION_MESSAGE =
    isUnlink ? `Selected contacts/lists will be unlinked from this campaign. You will still be able to access them from the main Audience.` :
      isDetailsPage
        ? `Removing the selected contact(s) will remove them from the list and they will no longer receive any emails sent to this list.`
        : (isSearchAddPeoplePage && addPeopleMode && globalList)
          ? `Adding the selected contact(s) will add them into the list (${listName}).`
          : (isSearchAddPeoplePage && addPeopleMode && !globalList)
            ? `Selected contact(s) will be removed from the list (${listName}).`
            : `Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?`;

  let CONFIRMATION_QUESTION = isUnlink ? 'Please confirm to proceed.' : null
  return (
    <Wrapper
      className={`${(((selectedCount && selectedCount > 0) || (selectedListCount && selectedListCount > 0)) && (globalList && addPeopleMode ? (totalCount > totalCountList) : true))
        || (addPeopleMode ? (deleteAllFlag && totalCount > totalCountList) : deleteAllFlag) ? "move-up" : ""
        } floating-footer d-flex justify-content-between`}
    >
      {confirm ? (
        <Suspense fallback={<></>}>
          <DialogWrapper>
            <ConfirmDialogWithModal
              cancel={CANCEL_BUTTON_TEXT}
              confirm={CONFIRM_BUTTON_TEXT}
              onConfirm={permanentDeleteContact || permanentDeleteContactConfirm ? onConfirmDelete : onConfirm}
              onCancel={onCancel}
              icon={whiteRoy}
              title={permanentDeleteContact ? "Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?" : permanentDeleteContactConfirm ?
                `${deleteAllFlag && !selectAll ?
                  (addPeopleMode && totalCountWithoutList && globalList && unselectedContactIdsState) ?
                    totalCountWithoutList - unselectedContactIdsState?.length
                    : deleteAllTotalCount
                  : selectAll
                    ? addPeopleMode && globalList ?
                      (totalCountWithoutList) : addPeopleMode && !globalList ? totalCountList : totalCount
                    : selectAllList
                      ? totalCountList
                      : selectedCount} contact(s) will be permanently deleted from all lists and your Workbench Audience.` : CONFIRMATION_MESSAGE}

              titleQuestion={CONFIRMATION_QUESTION}
            />
          </DialogWrapper>
        </Suspense>
      ) : null}
      {/* Toggle Class sidebar-opened  */}
      <div className="d-flex align-items-center">
        <div className="multi-select">
          <Checkbox checked={true} readOnly />
          <Checkbox checked={true} readOnly />
        </div>
        {isUnlink ?
          <span className="count" data-id="qa-list-count-selected" style={{ display: "inline-flex" }}>
            {`${selectedCount ? selectedCount === 1 ? "1 contact" : `${selectedCount} contacts` : ""} ${(selectedCount && selectedListCount) ? "and" : ""} ${(isUnlink && selectedListCount) ? (selectedListCount === 1 ? " 1 list" : ` ${selectedListCount} lists`) : ""}`} selected
          </span>
          : <span className="count" data-id="qa-list-count-selected" style={{ display: "inline-flex" }}>
            {deleteAllFlag && !selectAll ?
              (addPeopleMode && deleteAllTotalCount && globalList && unselectedContactIdsState) ?
                totalCountWithoutList - unselectedContactIdsState?.length
                : deleteAllTotalCount
              : selectAll
                ? addPeopleMode && globalList ?
                  (totalCountWithoutList) : addPeopleMode && !globalList ?
                    totalCountList : totalCount
                : selectAllList
                  ? totalCountList
                  : selectedCount}{" "}
            {selectedCount === 1 ? "contact" : "contacts"} selected
          </span>}
        <span className="clear" {...(onClearSelection ? { onClick: onClearSelection } : {})}>
          Clear selection
        </span>
      </div>
      <div className="d-flex align-items-center">


        {isUnlink ?
          <IconButton
            className={`btn-sm-primary align-self-center d-flex align-items-center ${loading ? "disabled" : ""}`}
            onClick={deleteHandler}
          >
            <MarginedImage src={Unlink} alt="icon" height={'17px'} width={'17px'} />
            Unlink
          </IconButton> :
          <>
            <Suspense fallback={<></>}>
              <FloatingNewListAsider
                tab={tab}
                inList={true}
                similarContacts={checkedItemsNewList}
                selectAllFlag={deleteAllFlag}
                unselectedContactIdsState={unselectedContactIdsState}
                deleteAllTotalCount={deleteAllTotalCount}
                selectAll={selectAll}
                selectAllList={selectAllList}
                selectedCount={selectedCount}
                deleteAllFlag={deleteAllFlag}
                selectedOrganization={selectedOrganization}
                selectedDesignation={selectedDesignation}
                selectedPersonality={selectedPersonality}
                selectedStatus={selectedStatus}
                idprefix="dynamic-list"
                idForRecommendedContacts={idForRecommendedContacts}
                fromGloabalListing={(isSearchAddPeoplePage && addPeopleMode && globalList) ? true : false}
                globalList={globalList}
                addPeopleMode={addPeopleMode}
              >
                <span className="create-list" onClick={createNewListHandler}>
                  {!urlContainsAdd && (globalListingWhenSearchInList || (onListPageOrGlobalList && onListPage) ? "Add to another List" : "Add to List")}
                </span>
              </FloatingNewListAsider>
            </Suspense>
            <Button
              value={`${DELETE_TEXT}`}
              className={`btn-sm-primary align-self-center ${loading ? "disabled" : ""}`}
              onClick={deleteHandler}
            />
            {
              onListPage && !addGlobalPeopleMode ?
                <Button
                  value={"Delete"}
                  className={`btn-sm-primary align-self-center ${loading ? "disabled" : ""} ${onListPage ? "btn-color list-footer-button" : ""}`}
                  onClick={permanentDelete}
                /> : <> </>
            }
          </>}
      </div>
    </Wrapper>
  );
};

export default DeleteSelected;

const Wrapper = styled.div`
  z-index: 1;
  transition: 1s;
  .create-list {
    font-family: "Roboto";
    font-weight: 500;
    font-size: 16px;
    color: #1ec252;
    cursor: pointer;
    margin-right: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &.floating-footer {
    z-index: 7;
    transition: 1s;
    background: #fff;
    border-top: 1px solid #e7e7e7;
    &.move-up {
      bottom: 0 !important;
      box-shadow: 0px -13px 10px rgb(0 0 0 / 10%);
    }
    position: fixed;
    bottom: -86px;
    left: 89px;
    width: calc(100% - 88px);
    padding: 20px 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
      left: 64px;
    }
    &.sidbar-opend {
      width: calc(100% - 634px);
    }
    .count {
      color: #7e7e7e;
      font-family: "Roboto Slab", serif;
      font-size: 18px;
      font-weight: 500;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    .clear {
      cursor: pointer;
      color: #27ce0a;
      font-size: 12px;
      font-weight: 400;
      font-family: "Roboto Slab", serif;
      padding-left: 6px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
      }
    }
    .multi-select {
      position: relative;
      width: 35px;
      height: 45px;
      > div {
        position: absolute;
        top: 10px;
        left: 0;
        z-index: 9;
        span {
          background-color: #fff;
        }
        + div {
          top: 15px;
          left: 5px;
          z-index: 8;
        }
      }
    }
  }
  .list-footer-button{
    margin-left: 10px;
  }
  .btn-color{
    background: #FFFFFF;
    border: 1px solid #7E7E7E;
    color: #7E7E7E;
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

const IconButton = styled(IcButton)`
  border-radius: 19px;
  border-color: #7E7E7E;
  font-family: "helveticaneuebold";
  color: #7E7E7E;
  background: #FFFFFF;
  :hover {
    background: #E6F5EA;    
  }
`;
const MarginedImage = styled.img`
  margin-right: 0.5em;
`;